<template>

  <b-row align-h="center" align="center">
    <b-col xs="12" sm="12" md="6" lg="3" xl="3">
      <b-row>
        <b-col>
          <h1>Catalogos</h1>

          <!--{{valorError}}-->
        </b-col>
      </b-row>

      <!--CATALOGO PRECIOS-->
      <b-row>
        <b-col>
          <p>Precios</p>
        </b-col>
        <b-col>
          <b-icon icon="arrow-down-circle-fill" font-scale="1" @click="descargaCatalogoPrecios"
            style="cursor: pointer;"></b-icon>
        </b-col>
      </b-row>
      <!--<b-row>
                                    <b-col>
                                        <b-form-file :state="Boolean(archivoPrecios)"
                                            placeholder="Adjunte catalogo de precios"
                                            @change="cargarCatalogoPrecios"></b-form-file>
                                    </b-col>
                                </b-row>
                                -->
      <b-row>
        <b-col>
          <b-button pill variant="success" size="lg" @click="capturaPrecios()">Cargar Precios</b-button>
          <p></p>
        </b-col>
        <b-modal v-model="modalShowPrecio" hide-footer header-text-variant="light" header-bg-variant="dark"
          title="Ingrese sus datos">

          <b-row align-h="center" align="center">
            <b-col>



              <b-row>
                <b-col>
                  <b-form-select v-model="proveedorSelectedValPrecio" :options="proveedoresPrecio"
                    value-field="proveedor" text-field="proveedor"></b-form-select>
                </b-col>
              </b-row>

              <p></p>
              <b-row>
                <b-col>
                  <b-form-select v-model="consumibleSelectedValPrecio"
                    :options="tipoConsumibleValPrecio"></b-form-select>
                </b-col>
              </b-row>
              <p></p>
              <b-row>
                <b-col>
                  <b-form-input class="text-center" type="number" number v-model="precio" placeholder="Precio"
                    :state="validacionPrecioAlta"></b-form-input>
                </b-col>
              </b-row>
              <p></p>

              <b-row align-h="center" align="center" v-if="banderaSpinnerPrecio == 0">
                <b-col>
                  <b-row v-if="precio != null && precio != ''">
                    <b-col>
                      <b-button pill variant="success" size="lg" @click="enviarPrecios()">Enviar Precios</b-button>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <p></p>
              <b-row v-if="banderaSpinnerPrecio == 1">
                <b-col>
                  <b-spinner label="Espere un momento, por favor..."></b-spinner>
                </b-col>
              </b-row>
              <p></p>
              <b-row v-if="banderaSpinnerPrecio == 2">
                <b-col>
                  <b-alert variant="success" show>LA MODIFICACIÓN SE HA REALIZADO CON EXITO</b-alert>
                  <b-button pill variant="success" size="lg" @click="cerrarPrecios()">Cerrar</b-button>
                </b-col>
              </b-row>

            </b-col>
          </b-row>

        </b-modal>
      </b-row>

      <!--CATALOGO UNIDADES-->
      <b-row>
        <b-col>
          <p>Unidades</p>
        </b-col>
        <b-col>
          <b-icon icon="arrow-down-circle-fill" font-scale="1" @click="descargaCatalogoUnidades"
            style="cursor: pointer;"></b-icon>
        </b-col>
      </b-row>
      <!--<b-row>
                                    <b-col>
                                        <b-form-file :state="Boolean(archivoUnidades)"
                                            placeholder="Adjunte catalogo de unidades"
                                            @change="cargarCatalogoUnidades"></b-form-file>
                                    </b-col>
                                </b-row>-->
      <b-row>
        <b-col>
          <p></p>
          <b-button pill variant="success" size="lg" @click="capturaUnidad()">Cargar Unidad</b-button>
          <p></p>
        </b-col>

        <b-modal v-model="modalShowUnidad" hide-footer header-text-variant="light" header-bg-variant="dark"
          title="Ingrese los datos del vehiculo">
          <b-row align-h="center" align="center">
            <b-col>


              <b-row>
                <b-col>
                  <b-form-select v-model="departamentoOpcionCarga" :options="departamentosCarga" value-field="nombre"
                    text-field="nombre"></b-form-select>
                </b-col>
              </b-row>
              <p></p>
              <b-row>
                <b-col>
                  <b-form-input class="text-center" v-model="placaCargaUnidad" placeholder="Número de placa"
                    :state="validacionPlacaUnidadAlta"></b-form-input>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-form-input class="text-center" v-model="numeroEconomico" placeholder="Número economico"
                    :state="validacionNumeroEconomicoUnidadAlta"></b-form-input>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-form-input class="text-center" v-model="unidad" placeholder="Unidad"
                    :state="validacionUnidadUnidadAlta"></b-form-input>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-form-input class="text-center" v-model="serieCargaUnidad" placeholder="Número de serie"
                    :state="validacionSerieUnidadAlta"></b-form-input>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-form-input class="text-center" v-model="marcaCargaUnidad" placeholder="Marca"
                    :state="validacionMarcaUnidadAlta"></b-form-input>
                </b-col>
              </b-row>

              <b-row>
                <b-col>
                  <b-form-input class="text-center" v-model="modeloCargaUnidad" placeholder="Modelo o sub marca"
                    :state="validacionSubMarcaUnidadAlta"></b-form-input>
                </b-col>
              </b-row>

              <b-row>
                <b-col>
                  <b-form-input class="text-center" type="number" number v-model="añoCargaUnidad"
                    placeholder="Modelo (año)" :state="validacionAñoUnidadAlta"></b-form-input>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-form-input class="text-center" v-model="colorCargaUnidad" placeholder="Color"
                    :state="validacionColorUnidadAlta"></b-form-input>
                </b-col>
              </b-row>

              <b-row>
                <b-col>
                  <b-form-input class="text-center" v-model="motorCargaUnidad" placeholder="Número de motor"
                    :state="validacionMotorUnidadAlta"></b-form-input>
                </b-col>
              </b-row>

              <b-row>
                <b-col>
                  <b-form-input class="text-center" v-model="inventarioCargaUnidad" placeholder="Número de inventario"
                    :state="validacionInventarioUnidadAlta"></b-form-input>
                </b-col>
              </b-row>
              <p></p>
              <b-row>
                <b-col>
                  <b-form-select v-model="consumibleSelectedValCarga" :options="tipoConsumibleValCarga"></b-form-select>
                </b-col>
              </b-row>

              <p></p>
              <b-row v-if="banderaSpinnerCargaUnidad == 0">
                <b-col>
                  <b-row
                    v-if="placaCargaUnidad != '' && numeroEconomico != '' && unidad != '' && serieCargaUnidad != '' && marcaCargaUnidad != '' && modeloCargaUnidad != '' && añoCargaUnidad != '' && colorCargaUnidad != '' && motorCargaUnidad != '' && inventarioCargaUnidad != ''">
                    <b-col>
                      <b-button pill variant="success" size="lg" @click="enviarUnidad()">Enviar Unidad</b-button>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <p></p>
              <b-row v-if="banderaSpinnerCargaUnidad == 1">
                <b-col>
                  <b-spinner label="Espere un momento, por favor..."></b-spinner>
                </b-col>
              </b-row>
              <p></p>
              <b-row v-if="banderaSpinnerCargaUnidad == 2">
                <b-col>
                  <b-alert :variant="contenidoAlertAltaUnidad.includes('Error') ? 'danger' : 'success'" show>{{
                    contenidoAlertAltaUnidad }}</b-alert>
                  <b-button pill variant="success" size="lg" @click="cerrarUnidad()">Cerrar</b-button>
                </b-col>
              </b-row>

            </b-col>
          </b-row>
        </b-modal>
      </b-row>

      <!--CATALOGO OPERADORES-->
      <!--
                        <b-row>
                            <b-col>
                                <p>Operadores</p>
                            </b-col>
                            <b-col>
                                <b-icon icon="arrow-down-circle-fill" font-scale="1" @click="descargaCatalogoOperadores" style="cursor: pointer;"></b-icon>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <b-form-file :state="Boolean(archivoOperadores)"
                                    placeholder="Adjunte catalogo de operadores"
                                    @change="cargarCatalogoOperadores"></b-form-file>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <p></p>
                                <b-button variant="success" size="lg" @click="enviarCatalogoOperadores()">CARGAR
                                    CATALOGO</b-button>
                                <p></p>
                            </b-col>
                        </b-row>
                        -->

      <!--CATALOGO DEPARTAMENTOS-->
      <!--
      <b-row>
        <b-col>
          <p>Departamentos</p>
        </b-col>
        <b-col>
          <b-icon icon="arrow-down-circle-fill" font-scale="1" @click="descargaCatalogoDepartamentos"
            style="cursor: pointer;"></b-icon>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-file :state="Boolean(archivoDepartamentos)" placeholder="Adjunte catalogo"
            @change="cargarCatalogoDepartamentos"></b-form-file>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <p></p>
          <b-button pill variant="success" size="lg" @click="enviarCatalogoDepartamentos()">Cargar Catalogo</b-button>
          <p></p>
        </b-col>
      </b-row>
      -->

      <!--CATALOGO PROVEDORES-->
      <!--
      <b-row>
        <b-col>
          <p>Proveedores</p>
        </b-col>
        <b-col>
          <b-icon icon="arrow-down-circle-fill" font-scale="1" @click="descargaCatalogoProveedores"
            style="cursor: pointer;"></b-icon>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-file :state="Boolean(archivoProveedores)" placeholder="Adjunte catalogo"
            @change="cargarCatalogoProveedores"></b-form-file>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <p></p>
          <b-button pill variant="success" size="lg" @click="enviarCatalogoProveedores()">Cargar Catalogo</b-button>
          <p></p>
        </b-col>
      </b-row>
      -->
    </b-col>
  </b-row>

</template>

<script>
import axios from "axios";
import FileSaver from "file-saver";

export default {
  computed: {
    validacionPrecioAlta() {
      return this.precio == '' ? false : true
    },

    validacionPlacaUnidadAlta() {
      return this.placaCargaUnidad == '' ? false : true
    },
    validacionNumeroEconomicoUnidadAlta() {
      return this.numeroEconomico == '' ? false : true
    },
    validacionUnidadUnidadAlta() {
      return this.unidad == '' ? false : true
    },
    validacionSerieUnidadAlta() {
      return this.serieCargaUnidad == '' ? false : true
    },
    validacionMarcaUnidadAlta() {
      return this.marcaCargaUnidad == '' ? false : true
    },
    validacionSubMarcaUnidadAlta() {
      return this.modeloCargaUnidad == '' ? false : true
    },
    validacionAñoUnidadAlta() {
      return this.añoCargaUnidad == '' ? false : true
    },
    validacionColorUnidadAlta() {
      return this.colorCargaUnidad == '' ? false : true
    },
    validacionMotorUnidadAlta() {
      return this.motorCargaUnidad == '' ? false : true
    },
    validacionInventarioUnidadAlta() {
      return this.inventarioCargaUnidad == '' ? false : true
    },

    token: {
      get: function () {
        return this.$store.state.user.token;
      },
      set: function (newIsWorking) {
        this.$store.commit("updateToken", newIsWorking);
      },
    },
  },

  data() {
    return {
      //variables Generacion Vale
      cliente: "",
      //url: "http://192.168.0.100:8080/",
      //url: "https://optimal-central-pug.ngrok-free.app/",
      url: "https://tphavawsqa.a.pinggy.link/",

      modalShowPrecio: 0,
      banderaSpinnerPrecio: 0,

      proveedorSelectedValPrecio: null,
      proveedoresPrecio: [],

      precio: "",

      consumibleSelectedValPrecio: "REGULAR",
      tipoConsumibleValPrecio: [
        { value: "REGULAR", text: "REGULAR" },
        { value: "PREMIUM", text: "PREMIUM" },
        { value: "DIESEL", text: "DIESEL" },
      ],

      modalShowUnidad: 0,
      banderaSpinnerCargaUnidad: 0,

      marcaCargaUnidad: "",
      modeloCargaUnidad: "",
      placaCargaUnidad: "",
      serieCargaUnidad: "",
      añoCargaUnidad: "",
      colorCargaUnidad: "",
      numeroEconomico: "",
      unidad: "",
      motorCargaUnidad: "",
      inventarioCargaUnidad: "",

      consumibleSelectedValCarga: "REGULAR",
      tipoConsumibleValCarga: [
        { value: "REGULAR", text: "REGULAR" },
        { value: "PREMIUM", text: "PREMIUM" },
        { value: "DIESEL", text: "DIESEL" },
      ],

      departamentoOpcionCarga: null,

      departamentos: [],
      departamentosCarga: [],

      archivoOperadores: null,
      archivoProveedores: null,
      archivoUnidades: null,
      archivoPrecios: null,
      archivoDepartamentos: null,

      archivoUnidadesBase64: "",
      archivoPreciosBase64: "",
      archivoOperadoresBase64: null,
      archivoProveedoresBase64: null,
      archivoDepartamentosBase64: null,

      preciosExcel: "",
      unidadesExcel: "",
      operadoresExcel: "",
      proveedoresExcel: "",
      departamentosExcel: "",

      contenidoAlertAltaUnidad: ""

      //valorError: ''
    };
  },

  created: function () {
    const queryString = window.location.href;

    const url = new URL(queryString);

    const cliente = url.pathname.split("/")[1];

    this.cliente = cliente;

    axios({
      method: "post",
      url: this.url + "catalogosum",
      params: { codeClient: this.cliente },
      data: null,
      headers: {
        'Authorization': this.token,

      }
    })
      .then((res) => {
        this.departamentos = res.data.departamentos;

        this.proveedores = res.data.proveedores;
      })
      .catch((err) => {

        if (err.response.status == 400 || err.response.status == 304 || err.response.status == 403 || err.response.status == 404) {

          alert('Servicio no disponible, intente de nuevo más tarde');

        }

        else if (err.response.status == 500) {

          alert('Error en la red, verifique su conexión a internet 4');
        }

        else {

          alert(err);

        }
      });
  },

  methods: {
    descargaCatalogoPrecios() {
      axios({
        method: "post",
        url: this.url + "precios",

        data: { nombre: "precios" },
        headers: {
          'Authorization': this.token,
        },
      })
        .then((res) => {
          this.archivoPreciosBase64 = res.data.xlsx;

          var byteString = atob(this.archivoPreciosBase64);
          var ab = new ArrayBuffer(byteString.length);
          var ia = new Uint8Array(ab);

          for (var i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
          }

          FileSaver.saveAs(
            new Blob([ab], { type: "application/octet-stream" }),
            "ejemplo.xlsx"
          );
        })
        .catch((err) => {
          //alert(err.config.headers.Authorization)

          //this.valorError = JSON.stringify(err.response);

          if (err.response.status == 400 || err.response.status == 304 || err.response.status == 403 || err.response.status == 404) {

            alert('Servicio no disponible, intente de nuevo más tarde');
          }

          else if (err.response.status == 500) {

            alert('Error en la red, verifique su conexión a internet');

          }

          else {

            if (err.config.headers.Authorization != null) {
              const queryString = window.location.href;
              const url = new URL(queryString);
              const cliente = url.pathname.split("/")[1];
              window.location.href = "/" + cliente + "/login";
            }

            //alert(err + " Servicio no disponible, intente de nuevo más tarde");

          }
        });
    },

    cargarCatalogoPrecios(evt) {
      if (evt.target.files.length > 0) {
        this.cargarCatalogoUnidades2(evt.target.files[0]);
      }
    },

    cargarCatalogoPrecios2(f) {
      var reader = new FileReader();
      // Closure to capture the file information.
      let obj = this;
      reader.onload = (function () {
        return function (theFile) {
          let binaryData = theFile.target.result;
          // Convertir datos binarios a base 64
          let base64String = window.btoa(binaryData);

          obj.preciosExcel = base64String;
        };
      })(f);

      // Read in the image file as a data URL.
      reader.readAsBinaryString(f);
    },

    capturaPrecios() {
      this.modalShowPrecio = 1;

      this.proveedoresPrecio = this.proveedores;
      this.proveedorSelectedValPrecio = this.proveedoresPrecio[0].proveedor

    },

    enviarPrecios() {
      this.banderaSpinnerPrecio = 1;

      axios({
        method: "post",
        url: this.url + "registraprecioconsumible",

        data: {
          tipoConsumible: this.consumibleSelectedValPrecio,
          precio: this.precio,
          proveedor: this.proveedorSelectedValPrecio,
        },
        headers: {
          'Authorization': this.token,
        },
      })
        .then(() => {
          this.registros = [];
          this.modalShowPrecio = 0;
          this.banderaSpinnerPrecio = 2;

          this.banderaSpinnerPrecio = 0;
          this.proveedorSelectedValPrecio = null;
          this.consumibleSelectedValPrecio = "REGULAR";
          this.precio = "";

          //alert(res.status == 200)
          //alert("entra al res")
          //alert(res.status)

          //this.valorError = JSON.stringify(res.status);

          this.refrescaCatalogos();
        })
        .catch((err) => {
          //alert(err.config.headers.Authorization)

          //this.valorError = JSON.stringify(err.response);

          if (err.response.status == 400 || err.response.status == 304 || err.response.status == 403 || err.response.status == 404) {

            alert('Servicio no disponible, intente de nuevo más tarde');
            this.banderaSpinnerPrecio = 0;

          }

          else if (err.response.status == 500) {

            alert('Error en la red, verifique su conexión a internet');
            this.banderaSpinnerPrecio = 0;
          }

          else {

            if (err.config.headers.Authorization != null) {
              const queryString = window.location.href;
              const url = new URL(queryString);
              const cliente = url.pathname.split("/")[1];
              window.location.href = "/" + cliente + "/login";
            }



            //alert(err)

            //alert(err + " Servicio no disponible, intente de nuevo más tarde");

          }
        });
    },

    cerrarPrecios() {
      this.modalShowPrecio = 0;
    },

    descargaCatalogoUnidades() {
      axios({
        method: "post",
        url: this.url + "catalogo",

        data: { nombre: "unidades" },
        headers: {
          'Authorization': this.token,
        },
      })
        .then((res) => {
          this.archivoUnidadesBase64 = res.data.xlsx;

          var byteString = atob(this.archivoUnidadesBase64);
          var ab = new ArrayBuffer(byteString.length);
          var ia = new Uint8Array(ab);

          for (var i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
          }

          FileSaver.saveAs(
            new Blob([ab], { type: "application/octet-stream" }),
            "ejemplo.xlsx"
          );
        })
        .catch((err) => {
          //alert(err.config.headers.Authorization)

          //this.valorError = JSON.stringify(err.response);

          if (err.response.status == 400 || err.response.status == 304 || err.response.status == 403 || err.response.status == 404) {

            alert('Servicio no disponible, intente de nuevo más tarde');

          }

          else if (err.response.status == 500) {

            alert('Error en la red, verifique su conexión a internet');

          }

          else {

            if (err.config.headers.Authorization != null) {
              const queryString = window.location.href;
              const url = new URL(queryString);
              const cliente = url.pathname.split("/")[1];
              window.location.href = "/" + cliente + "/login";
            }

            //alert(err + " Servicio no disponible, intente de nuevo más tarde");
          }
        });
    },

    cargarCatalogoUnidades(evt) {
      if (evt.target.files.length > 0) {
        this.cargarCatalogoUnidades2(evt.target.files[0]);
      }
    },

    cargarCatalogoUnidades2(f) {
      var reader = new FileReader();
      // Closure to capture the file information.
      let obj = this;
      reader.onload = (function () {
        return function (theFile) {
          let binaryData = theFile.target.result;
          // Convertir datos binarios a base 64
          let base64String = window.btoa(binaryData);

          obj.unidadesExcel = base64String;
        };
      })(f);

      // Read in the image file as a data URL.
      reader.readAsBinaryString(f);
    },

    capturaUnidad() {
      this.modalShowUnidad = 1;

      this.departamentosCarga = this.departamentos;
      this.departamentoOpcionCarga = this.departamentosCarga[0].nombre
    },

    enviarUnidad() {
      this.banderaSpinnerCargaUnidad = 1;

      axios({
        method: "post",
        url: this.url + "registraunidad",

        data: {
          descDepartamento: this.departamentoOpcionCarga,
          placa: this.placaCargaUnidad,
          NoEconomico: this.numeroEconomico,
          unidad: this.unidad,
          serie: this.serieCargaUnidad,
          marca: this.marcaCargaUnidad,
          subMarca: this.modeloCargaUnidad,
          modelo: this.añoCargaUnidad,
          color: this.colorCargaUnidad,
          motor: this.motorCargaUnidad,
          inventario: this.inventarioCargaUnidad,
          tipoCombustible: this.consumibleSelectedValCarga,
        },
        headers: {
          'Authorization': this.token,
        },
      })
        .then((res) => {
          this.registros = [];
          //this.modalShowUnidad = 0;
          this.banderaSpinnerCargaUnidad = 2;

          this.banderaSpinnerCargaUnidad = 0;
          this.marcaCargaUnidad = "";
          this.modeloCargaUnidad = "";
          this.placaCargaUnidad = "";
          this.serieCargaUnidad = "";
          this.añoCargaUnidad = "";
          this.colorCargaUnidad = "";
          this.numeroEconomico = "";
          this.unidad = "";
          this.motorCargaUnidad = "";
          this.inventarioCargaUnidad = "";
          this.consumibleSelectedValCarga = "REGULAR";
          this.departamentoOpcionCarga = null;


          this.banderaSpinnerCargaUnidad = 2

          this.contenidoAlertAltaUnidad = res.data

          //alert(this.contenidoAlertAltaFactura.proveedor)

          if (this.contenidoAlertAltaUnidad.descDepartamento != null) {

            this.contenidoAlertAltaUnidad = "UNIDAD AGREGADA EXITOSAMENTE"

            this.refrescaCatalogos();
          }

        })
        .catch((err) => {
          //alert(err.config.headers.Authorization)

          //this.valorError = JSON.stringify(err.response);

          if (err.response.status == 400 || err.response.status == 304 || err.response.status == 403 || err.response.status == 404) {

            alert('Servicio no disponible, intente de nuevo más tarde');

          }

          else if (err.response.status == 500) {

            alert('Error en la red, verifique su conexión a internet');

          }

          else {

            if (err.config.headers.Authorization != null) {
              const queryString = window.location.href;
              const url = new URL(queryString);
              const cliente = url.pathname.split("/")[1];
              window.location.href = "/" + cliente + "/login";
            }

            this.banderaSpinnerCargaUnidad = 0;

            //alert(err + " Servicio no disponible, intente de nuevo más tarde");
          }
        });
    },

    cerrarUnidad() {
      this.modalShowUnidad = 0;
      this.banderaSpinnerCargaUnidad = 0;
      this.marcaCargaUnidad = "";
      this.modeloCargaUnidad = "";
      this.placaCargaUnidad = "";
      this.serieCargaUnidad = "";
      this.añoCargaUnidad = "";
      this.colorCargaUnidad = "";
      this.numeroEconomico = "";
      this.unidad = "";
      this.motorCargaUnidad = "";
      this.inventarioCargaUnidad = "";
      this.consumibleSelectedValCarga = "REGULAR";
      this.departamentoOpcionCarga = null;


      this.banderaSpinnerCargaUnidad = 0;

    },

    descargaCatalogoOperadores() {
      axios({
        method: "post",
        url: this.url + "catalogo",

        data: { nombre: "operadores" },
        headers: {
          'Authorization': this.token,
        },
      })
        .then((res) => {
          this.archivoOperadoresBase64 = res.data.xlsx;

          var byteString = atob(this.archivoOperadoresBase64);
          var ab = new ArrayBuffer(byteString.length);
          var ia = new Uint8Array(ab);

          for (var i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
          }

          FileSaver.saveAs(
            new Blob([ab], { type: "application/octet-stream" }),
            "ejemplo.xlsx"
          );
        })
        .catch((err) => {
          //alert(err.config.headers.Authorization)

          //this.valorError = JSON.stringify(err.response);

          if (err.response.status == 400 || err.response.status == 304 || err.response.status == 403 || err.response.status == 404) {

            alert('Servicio no disponible, intente de nuevo más tarde');

          }

          else if (err.response.status == 500) {

            alert('Error en la red, verifique su conexión a internet');

          }

          else {

            if (err.config.headers.Authorization != null) {
              const queryString = window.location.href;
              const url = new URL(queryString);
              const cliente = url.pathname.split("/")[1];
              window.location.href = "/" + cliente + "/login";
            }

            //alert(err + " Servicio no disponible, intente de nuevo más tarde");
          }
        });
    },

    cargarCatalogoOperadores(evt) {
      if (evt.target.files.length > 0) {
        this.cargarCatalogoOperadores2(evt.target.files[0]);
      }
    },

    cargarCatalogoOperadores2(f) {
      var reader = new FileReader();
      // Closure to capture the file information.
      let obj = this;
      reader.onload = (function () {
        return function (theFile) {
          let binaryData = theFile.target.result;
          // Convertir datos binarios a base 64
          let base64String = window.btoa(binaryData);

          obj.operadoresExcel = base64String;
        };
      })(f);

      // Read in the image file as a data URL.
      reader.readAsBinaryString(f);
    },

    enviarCatalogoOperadores() {
      axios({
        method: "post",
        url: this.url + "cargacatalogo",

        data: {
          nombre: "operadores",
          xlsx: this.operadoresExcel,
        },
        headers: {
          'Authorization': this.token,
        },
      })
        .then(() => {
          this.registros = [];
          this.refrescaCatalogos();
        })
        .catch((err) => {
          //alert(err.config.headers.Authorization)

          //this.valorError = JSON.stringify(err.response);

          if (err.response.status == 400 || err.response.status == 304 || err.response.status == 403 || err.response.status == 404) {

            alert('Servicio no disponible, intente de nuevo más tarde');

          }

          else if (err.response.status == 500) {

            alert('Error en la red, verifique su conexión a internet');

          }

          else {

            if (err.config.headers.Authorization != null) {
              const queryString = window.location.href;
              const url = new URL(queryString);
              const cliente = url.pathname.split("/")[1];
              window.location.href = "/" + cliente + "/login";
            }

            //alert(err + " Servicio no disponible, intente de nuevo más tarde");
          }
        });
    },

    descargaCatalogoProveedores() {
      axios({
        method: "post",
        url: this.url + "catalogo",

        data: { nombre: "proveedores" },
        headers: {
          'Authorization': this.token,
        },
      })
        .then((res) => {
          this.archivoProveedoresBase64 = res.data.xlsx;

          var byteString = atob(this.archivoProveedoresBase64);
          var ab = new ArrayBuffer(byteString.length);
          var ia = new Uint8Array(ab);

          for (var i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
          }

          FileSaver.saveAs(
            new Blob([ab], { type: "application/octet-stream" }),
            "ejemplo.xlsx"
          );
        })
        .catch((err) => {
          //alert(err.config.headers.Authorization)

          //this.valorError = JSON.stringify(err.response);

          if (err.response.status == 400 || err.response.status == 304 || err.response.status == 403 || err.response.status == 404) {

            alert('Servicio no disponible, intente de nuevo más tarde');

          }

          else if (err.response.status == 500) {

            alert('Error en la red, verifique su conexión a internet');

          }

          else {

            if (err.config.headers.Authorization != null) {
              const queryString = window.location.href;
              const url = new URL(queryString);
              const cliente = url.pathname.split("/")[1];
              window.location.href = "/" + cliente + "/login";
            }

            //alert(err + " Servicio no disponible, intente de nuevo más tarde");
          }
        });
    },

    cargarCatalogoProveedores(evt) {
      if (evt.target.files.length > 0) {
        this.cargarCatalogoProveedores2(evt.target.files[0]);
      }
    },

    cargarCatalogoProveedores2(f) {
      var reader = new FileReader();
      // Closure to capture the file information.
      let obj = this;
      reader.onload = (function () {
        return function (theFile) {
          let binaryData = theFile.target.result;
          // Convertir datos binarios a base 64
          let base64String = window.btoa(binaryData);

          obj.proveedoresExcel = base64String;
        };
      })(f);

      // Read in the image file as a data URL.
      reader.readAsBinaryString(f);
    },

    enviarCatalogoProveedores() {
      axios({
        method: "post",
        url: this.url + "cargacatalogo",

        data: {
          nombre: "proveedores",
          xlsx: this.proveedoresExcel,
        },
        headers: {
          'Authorization': this.token,
        },
      })
        .then(() => {
          this.registros = [];
          this.refrescaCatalogos();
        })
        .catch((err) => {
          //alert(err.config.headers.Authorization)

          //this.valorError = JSON.stringify(err.response);

          if (err.response.status == 400 || err.response.status == 304 || err.response.status == 403 || err.response.status == 404) {

            alert('Servicio no disponible, intente de nuevo más tarde');
          }

          else if (err.response.status == 500) {

            alert('Error en la red, verifique su conexión a internet');

          }
          else {

            if (err.config.headers.Authorization != null) {
              const queryString = window.location.href;
              const url = new URL(queryString);
              const cliente = url.pathname.split("/")[1];
              window.location.href = "/" + cliente + "/login";
            }

            //alert(err + " Servicio no disponible, intente de nuevo más tarde");

          }
        });
    },

    descargaCatalogoDepartamentos() {
      axios({
        method: "post",
        url: this.url + "catalogo",

        data: { nombre: "departamentos" },
        headers: {
          'Authorization': this.token,
        },
      })
        .then((res) => {
          this.archivoDepartamentosBase64 = res.data.xlsx;

          var byteString = atob(this.archivoDepartamentosBase64);
          var ab = new ArrayBuffer(byteString.length);
          var ia = new Uint8Array(ab);

          for (var i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
          }

          FileSaver.saveAs(
            new Blob([ab], { type: "application/octet-stream" }),
            "ejemplo.xlsx"
          );
        })
        .catch((err) => {
          //alert(err.config.headers.Authorization)

          //this.valorError = JSON.stringify(err.response);

          if (err.response.status == 400 || err.response.status == 304 || err.response.status == 403 || err.response.status == 404) {

            alert('Servicio no disponible, intente de nuevo más tarde');
          }

          else if (err.response.status == 500) {

            alert('Error en la red, verifique su conexión a internet');

          }

          else {

            if (err.config.headers.Authorization != null) {
              const queryString = window.location.href;
              const url = new URL(queryString);
              const cliente = url.pathname.split("/")[1];
              window.location.href = "/" + cliente + "/login";
            }

            //alert(err + " Servicio no disponible, intente de nuevo más tarde");
          }
        });
    },

    cargarCatalogoDepartamentos(evt) {
      if (evt.target.files.length > 0) {
        this.cargarCatalogoDepartamentos2(evt.target.files[0]);
      }
    },

    cargarCatalogoDepartamentos2(f) {
      var reader = new FileReader();
      // Closure to capture the file information.
      let obj = this;
      reader.onload = (function () {
        return function (theFile) {
          let binaryData = theFile.target.result;
          // Convertir datos binarios a base 64
          let base64String = window.btoa(binaryData);

          obj.departamentosExcel = base64String;
        };
      })(f);

      // Read in the image file as a data URL.
      reader.readAsBinaryString(f);
    },

    enviarCatalogoDepartamentos() {
      axios({
        method: "post",
        url: this.url + "cargacatalogo",

        data: {
          nombre: "departamentos",
          xlsx: this.departamentosExcel,
        },
        headers: {
          'Authorization': this.token,
        },
      })
        .then(() => {
          this.registros = [];
          this.refrescaCatalogos();
        })
        .catch((err) => {
          //alert(err.config.headers.Authorization)

          //this.valorError = JSON.stringify(err.response);

          if (err.response.status == 400 || err.response.status == 304 || err.response.status == 403 || err.response.status == 404) {

            alert('Servicio no disponible, intente de nuevo más tarde');
          }

          else if (err.response.status == 500) {

            alert('Error en la red, verifique su conexión a internet');

          }

          else {

            if (err.config.headers.Authorization != null) {
              const queryString = window.location.href;
              const url = new URL(queryString);
              const cliente = url.pathname.split("/")[1];
              window.location.href = "/" + cliente + "/login";
            }

            //alert(err + " Servicio no disponible, intente de nuevo más tarde");
          }

        });
    },

    refrescaCatalogos() {

      axios({
        method: 'post',
        url: this.url + 'catalogosum',
        params: { "codeClient": this.cliente },
        data: null,
        headers: {
          'Authorization': this.token,

        }
      })
        .then((res) => {
          this.departamentos = res.data.departamentos
          this.unidades = res.data.unidades
          this.operadores = res.data.operadores
          this.proveedores = res.data.proveedores

          this.unidadesTabla = res.data.unidades

        }).catch(err => {

          if (err.response.status == 400 || err.response.status == 304 || err.response.status == 403 || err.response.status == 404) {

            alert('Servicio no disponible, intente de nuevo más tarde');

          }

          else if (err.response.status == 500) {

            alert('Error en la red, verifique su conexión a internet 1');
          }

          else {

            alert(err);

          }
        });

    }
  },
};
</script>

<style>
/* BASIC */

html {
  background-color: #ffffff;
}

body {
  font-family: "Poppins", sans-serif;
  height: 100vh;
}

a {
  color: #ffffff;
  display: inline-block;
  text-decoration: none;
  font-weight: 400;
}

h2 {
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  text-transform: uppercase;
  display: inline-block;
  margin: 40px 8px 10px 8px;
  color: #cccccc;
}

/* STRUCTURE */

.wrapper {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  min-height: 100%;
  padding: 20px;
}

#formContent {
  -webkit-border-radius: 10px 10px 10px 10px;
  border-radius: 10px 10px 10px 10px;
  background: #fff;
  padding: 30px;
  width: 90%;
  max-width: 450px;
  position: relative;
  padding: 0px;
  -webkit-box-shadow: 0 30px 60px 0 rgba(0, 0, 0, 0.3);
  box-shadow: 0 30px 60px 0 rgba(0, 0, 0, 0.3);
  text-align: center;
}

#formFooter {
  background-color: #f6f6f6;
  border-top: 1px solid #dce8f1;
  padding: 25px;
  text-align: center;
  -webkit-border-radius: 0 0 10px 10px;
  border-radius: 0 0 10px 10px;
}

/* TABS */

h2.inactive {
  color: #cccccc;
}

h2.active {
  color: #0d0d0d;
  border-bottom: 2px solid #5fbae9;
}

/* FORM TYPOGRAPHY*/

input[type="button"],
input[type="submit"],
input[type="reset"] {
  background-color: #ffffff;
  border: none;
  color: white;
  padding: 15px 80px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  text-transform: uppercase;
  font-size: 13px;
  -webkit-box-shadow: 0 10px 30px 0 rgba(95, 186, 233, 0.4);
  box-shadow: 0 10px 30px 0 rgba(95, 186, 233, 0.4);
  -webkit-border-radius: 5px 5px 5px 5px;
  border-radius: 5px 5px 5px 5px;
  margin: 5px 20px 40px 20px;
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
}

input[type="button"]:hover,
input[type="submit"]:hover,
input[type="reset"]:hover {
  background-color: #ffffff;
}

input[type="button"]:active,
input[type="submit"]:active,
input[type="reset"]:active {
  -moz-transform: scale(0.95);
  -webkit-transform: scale(0.95);
  -o-transform: scale(0.95);
  -ms-transform: scale(0.95);
  transform: scale(0.95);
}

input[type="text"] {
  background-color: #f6f6f6;
  border: none;
  color: #0d0d0d;
  padding: 15px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 5px;
  width: 85%;
  border: 2px solid #f6f6f6;
  -webkit-transition: all 0.5s ease-in-out;
  -moz-transition: all 0.5s ease-in-out;
  -ms-transition: all 0.5s ease-in-out;
  -o-transition: all 0.5s ease-in-out;
  transition: all 0.5s ease-in-out;
  -webkit-border-radius: 5px 5px 5px 5px;
  border-radius: 5px 5px 5px 5px;
}

input[type="text"]:focus {
  background-color: #fff;
  border-bottom: 2px solid #5fbae9;
}

input[type="text"]:placeholder {
  color: #cccccc;
}

/* ANIMATIONS */

/* Simple CSS3 Fade-in-down Animation */
.fadeInDown {
  -webkit-animation-name: fadeInDown;
  animation-name: fadeInDown;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

@-webkit-keyframes fadeInDown {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, -100%, 0);
    transform: translate3d(0, -100%, 0);
  }

  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}

@keyframes fadeInDown {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, -100%, 0);
    transform: translate3d(0, -100%, 0);
  }

  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}

/* Simple CSS3 Fade-in Animation */
@-webkit-keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@-moz-keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.card-option {
  box-shadow: 0px 5px 35px 5px #cccaca;
  border-radius: 15px;
  border-bottom: solid 4px rgb(68, 63, 173);
  background-color: white;
}

.fadeIn {
  opacity: 0;
  -webkit-animation: fadeIn ease-in 1;
  -moz-animation: fadeIn ease-in 1;
  animation: fadeIn ease-in 1;

  -webkit-animation-fill-mode: forwards;
  -moz-animation-fill-mode: forwards;
  animation-fill-mode: forwards;

  -webkit-animation-duration: 1s;
  -moz-animation-duration: 1s;
  animation-duration: 1s;
}

.fadeIn.first {
  -webkit-animation-delay: 0.4s;
  -moz-animation-delay: 0.4s;
  animation-delay: 0.4s;
}

.fadeIn.second {
  -webkit-animation-delay: 0.6s;
  -moz-animation-delay: 0.6s;
  animation-delay: 0.6s;
}

.fadeIn.third {
  -webkit-animation-delay: 0.8s;
  -moz-animation-delay: 0.8s;
  animation-delay: 0.8s;
}

.fadeIn.fourth {
  -webkit-animation-delay: 1s;
  -moz-animation-delay: 1s;
  animation-delay: 1s;
}

/* Simple CSS3 Fade-in Animation */
.underlineHover:after {
  display: block;
  left: 0;
  bottom: -10px;
  width: 0;
  height: 2px;
  background-color: #56baed;
  content: "";
  transition: width 0.2s;
}

.underlineHover:hover {
  color: #0d0d0d;
}

.underlineHover:hover:after {
  width: 100%;
}

/* OTHERS */

*:focus {
  outline: none;
}

#icon {
  width: 60%;
}
</style>
